export default __webpack_public_path__ + "static/media/gallery-wip-pre-paint_03.0f3e017f.jpg";